import axios from "axios";
import Modal from "react-modal";
import Select from "react-select";
import ReactQuill from "react-quill";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  Trash2,
  Plus,
  Copy,
  Gem,
  Layers,
  Image as ImageIcon,
  Briefcase,
  Upload,
  CheckCircle,
  EllipsisVertical,
  Pencil,
  X,
} from "lucide-react";

import defualtImage from "../../../../resources/assets/images/add-image.png";
import AlertBox from "../../../../Components/AlertComp/AlertBox";

const AddProduct = () => {
  // variation
  const url = process.env.REACT_APP_API_URL;
  const adminToken = localStorage.getItem("token");
  const axiosConfig = {
    headers: {
      Authorization: adminToken,
      "Content-Type": "application/json",
    },
  };
  const Navigate = useNavigate();

  const [variations, setVariations] = useState([
    createNewVariationObject("v-1", "Yellow Gold"),
  ]);

  useEffect(() => {
    console.log("variations ==> ", variations);
  }, [variations]);

  const [activeVarId, setActiveVarId] = useState("v-1");
  const [activeMetalSizeId, setActiveMetalSizeId] = useState(
    variations[0]?.metalSizes[0]?._uiId || "",
  );
  const [activeDiamondSizeId, setActiveDiamondSizeId] = useState(() => {
    const m = variations[0]?.metalSizes?.[0];
    return m?.diamondSizes?.[0]?._uiId || "";
  });
  const [showColorModal, setColorModal] = useState(false);

  const [uploadColor, setUploadColor] = useState("");
  const [tempUploadedImages, setTempUploadedImages] = useState([]);
  const [tempSelectedImages, setTempSelectedImages] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingGroupIndex, setEditingGroupIndex] = useState(null);
  const [editingGroupSource, setEditingGroupSource] = useState(null);

  const [modalTab, setModalTab] = useState("upload");

  // product
  const [productName, setProductName] = useState("");

  const [productImages, setProductImages] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [data, setData] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCollection, setSelectedCollection] = useState("");
  const [description, setDescription] = useState("");
  const [productAddStatus, setProductAddStatus] = useState();
  const [statusMessage, setStatusMessage] = useState("");

  const [metalTypes, setMetalTypes] = useState([
    "",
    "Gold",
    "Silver",
    "Platinum",
  ]);
  const [metalTypeInput, setMetalTypeInput] = useState("");

  const [purities, setPurities] = useState([
    "",
    "9k",
    "10k",
    "14k",
    "18k",
    "21k",
    "22k",
    "24k",
  ]);
  const [metalPurityInput, setMetalPurityInput] = useState("");

  const [diamondTypes, setDiamondTypes] = useState([
    "",
    "Sapphire",
    "Ruby",
    "Emerald",
  ]);
  const [diamondTypeInput, setDiamondTypeInput] = useState("");

  const [metalSizesList, setMetalSizesList] = useState(["", "11"]);
  const [metalSizeInput, setMetalSizeInput] = useState("");

  const [diamondRates, setDiamondRates] = useState();
  const [metalRates, setMetalRates] = useState();

  const [allProductImages, setAllProductImages] = useState([]);
  const [shapes, setShaps] = useState([]);

  const deleteColorGroup = (varId, groupIndex, source) => {
    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== varId) return v;

        if (source === "colors") {
          return {
            ...v,
            colors: v.colors.filter((_, i) => i !== groupIndex),
          };
        }

        if (source === "existingColors") {
          return {
            ...v,
            existingColors: v.existingColors.filter((_, i) => i !== groupIndex),
          };
        }

        return v;
      }),
    );
  };

  const deleteSingleImage = (varId, groupIndex, imageIndex, source) => {
    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== varId) return v;

        const target = source === "colors" ? v.colors : v.existingColors;

        const updatedGroups = target.map((g, i) => {
          if (i !== groupIndex) return g;

          return {
            ...g,
            images: g.images.filter((_, idx) => idx !== imageIndex),
          };
        });

        return {
          ...v,
          [source]: updatedGroups,
        };
      }),
    );
  };

  const fetchDiamondRates = async () => {
    try {
      const res = await axios.get(`${url}/diamond`, axiosConfig);
      const data = Array.isArray(res.data) ? res.data : res.data.data;
      setDiamondRates(data);
    } catch (error) {
      console.error("Failed to fetch diamond rates", error);
      setDiamondRates([]);
    }
  };

  const fetchMetalPrices = async () => {
    try {
      const response = await axios.get(`${url}/metal`, axiosConfig);
      const metalsArray = response.data.data || response.data;
      setMetalRates(metalsArray);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchProductImages = async () => {
    try {
      const res = await axios.get(`${url}/product/get-all-images`, axiosConfig);
      const data = Array.isArray(res.data) ? res.data : res.data.data;
      setAllProductImages(data?.product);
    } catch (error) {
      console.error("Failed to fetch images", error);
      setAllProductImages([]);
    }
  };

  useEffect(() => {
    fetchMetalPrices();
    fetchDiamondRates();
    fetchProductImages();
  }, []);

  useEffect(() => {
    if (diamondRates) {
      const uniqueShapes = [
        ...new Set(diamondRates?.map((item) => item.shape)),
      ];
      setShaps(uniqueShapes);
    }
  }, [diamondRates]);

  function getMetalMaster(metalType, metalRates) {
    return metalRates?.find(
      (m) => m.metalName.toLowerCase() === metalType.toLowerCase(),
    );
  }

  function parsePurity(purity) {
    return Number(String(purity).replace("k", ""));
  }

  function calculateMetalPriceFrontend(metalComponent, metalRates) {
    const master = getMetalMaster(metalComponent.metalType, metalRates);
    if (!master) return { rate: 0, cost: 0 };

    const purity = parsePurity(metalComponent.purity);
    const weight = Number(metalComponent.weight || 0);

    const purityFactor = purity / master.basePurity;
    const ratePerGram = master.baseRate * purityFactor;
    const cost = ratePerGram * weight;

    return {
      rate: Number(ratePerGram.toFixed(2)),
      cost: Number(cost.toFixed(2)),
    };
  }

  function calculateRoundDiamondFrontend(component) {
    const { shape, mmSize, stones } = component;
    if (!mmSize || !stones) return null;
    const master = diamondRates?.find(
      (d) => d.shape == shape && d.mm == Number(mmSize),
    );
    if (!master) {
      const manual = Number(component.manualPrice || 0);
      if (!manual) return null;

      return {
        avgCaratPerStone: 0,
        totalCrt: 0,
        qualityVariants: [
          {
            quality: "single",
            pricePerCrt: manual,
            finalPrice: Number(manual.toFixed(2)),
            active: true,
          },
        ],
      };
    }

    const priceMode = master.priceMode || "quality";

    if (priceMode === "single") {
      const rate = Number(master.singlePrice || 0);
      const qualityVariants = [
        {
          quality: "single",
          pricePerCrt: rate,
          finalPrice: Number(rate.toFixed(2)),
          active: true,
        },
      ];

      return {
        avgCaratPerStone: 0,
        totalCrt: 0,
        qualityVariants,
      };
    }

    const avgCaratPerStone = master.caratWeight;
    const totalCrt = avgCaratPerStone * Number(stones);

    // ✅ normalize master quality keys
    const normalizedRates = {};
    Object.entries(master.qualityRates || {}).forEach(([k, v]) => {
      normalizedRates[k.toLowerCase().trim()] = v;
    });

    // ✅ DIRECTLY CREATE qualityVariants (NO MAPPING)
    const qualityVariants = Object.entries(normalizedRates).map(
      ([qualityKey, rate], index) => ({
        quality: qualityKey,
        pricePerCrt: rate,
        finalPrice: Number((rate * totalCrt).toFixed(2)),
        active: index === 0,
      }),
    );

    return {
      avgCaratPerStone: Number(avgCaratPerStone.toFixed(4)),
      totalCrt: Number(totalCrt.toFixed(3)),
      qualityVariants, // 🔥 PUSHED DIRECTLY
    };
  }

  const getMasterForDiamond = (d) =>
    diamondRates?.find(
      (rate) =>
        rate.shape == d.shape && Number(rate.mm) === Number(d.mmSize),
    );

  const getManualPriceValue = (d) => {
    const master = getMasterForDiamond(d);
    if (master?.priceMode === "single") return master.singlePrice ?? "";
    return d.manualPrice || "";
  };

  const isManualPriceLocked = (d) =>
    getMasterForDiamond(d)?.priceMode === "single";

  function createNewVariationObject(id, name) {
    return {
      tempId: id,
      variationName: name,
      variationStock: "Available",
      colors: [],
      existingColors: [],

      metalSizes: [
        {
          _uiId: "m-" + crypto.randomUUID(),
          sizeLabel: "11",
          active: true,
          metalComponents: [
            {
              metalType: "Gold",
              purity: "18k",
              size: "11",
              weight: 0,
              rate: 0,
            },
          ],
          metalCharges: { labour: 0, making: 0 },
          diamondInvolved: false,
          diamondSizes: [],
        },
      ],
    };
  }

  const currentVar =
    variations.find((v) => v.tempId === activeVarId) || variations[0];
  const currentMetalSize =
    currentVar.metalSizes.find((s) => s._uiId === activeMetalSizeId) ||
    currentVar.metalSizes[0];

  const MetalTotalCost = () => {
    return (
      (currentMetalSize?.metalComponents?.reduce(
        (acc, m) => acc + Number(m.weight || 0) * Number(m.rate || 0),
        0,
      ) || 0) +
      (Number(currentMetalSize?.metalCharges?.labour) || 0) +
      (Number(currentMetalSize?.metalCharges?.making) || 0)
    );
  };

  const calculateQualityPrice = (q) => {
    const otherTypesTotal = q.otherTypes?.reduce(
      (s, o) =>
        s +
        Number(o.price || 0) +
        Number(o.labour || 0) +
        Number(o.making || 0),
      0,
    );
    const total =
      otherTypesTotal != undefined
        ? Number(q?.finalPrice || 0) + otherTypesTotal
        : Number(q?.finalPrice || 0);
    return total;
  };

  const getQualityTotals = (diamondSize) => {
    const totals = {
      lab_vvs_vs: 0,
      natural_fg_vs: 0,
      natural_gh_si: 0,
      natural_hi_si: 0,
    };

    if (!diamondSize?.diamondComponents?.length) return totals;

    diamondSize.diamondComponents.forEach((component) => {
      (component.qualityVariants || []).forEach((q) => {
        const key = (q.quality || "").toLowerCase();
        const price = Number(calculateQualityPrice(q) || 0);
        if (Object.prototype.hasOwnProperty.call(totals, key)) {
          totals[key] += price;
          return;
        }
        // Single-price diamonds: add the price to all quality buckets
        if (key === "single" || !key) {
          Object.keys(totals).forEach((k) => {
            totals[k] += price;
          });
        }
      });
    });

    return totals;
  };

  const currentDiamondSize =
    currentMetalSize?.diamondSizes?.find(
      (d) => d._uiId === activeDiamondSizeId,
    ) || currentMetalSize?.diamondSizes?.[0];

  const qualityTotals = currentDiamondSize?.diamondComponents?.length
    ? getQualityTotals(currentDiamondSize)
    : null;

  // --- CALCULATION LOGIC ---
  const calculateTotal = (data) => {
    return data.map((v) => {
      // Always calculate based on FIRST active size
      const metalSize =
        v.metalSizes?.find((s) => s.active) || v.metalSizes?.[0];
      const diamondSize =
        metalSize?.diamondSizes?.find((s) => s.active) ||
        metalSize.diamondSizes?.[0];

      /* ---------------- METAL ---------------- */
      const metalSubtotal =
        metalSize?.metalComponents?.reduce(
          (acc, m) => acc + Number(m.weight || 0) * Number(m.rate || 0),
          0,
        ) || 0;
      const metalTotal =
        metalSubtotal +
        Number(metalSize?.metalCharges?.labour || 0) +
        Number(metalSize?.metalCharges?.making || 0);

      /* ---------------- DIAMOND ---------------- */
      let diamondTotal = 0;
      if (metalSize?.diamondInvolved && diamondSize) {
        const diamondSubtotal =
          diamondSize.diamondComponents?.reduce((acc, d) => {
            const activeQuality = d.qualityVariants?.find((q) => q.active);
            const otherTypesTotal =
              activeQuality?.otherTypes?.reduce(
                (s, o) => s + Number(o.price || 0),
                0,
              ) || 0;
            return acc + (activeQuality?.finalPrice || 0) + otherTypesTotal;
          }, 0) || 0;

        diamondTotal =
          diamondSubtotal +
          Number(diamondSize.diamondCharges?.labour || 0) +
          Number(diamondSize.diamondCharges?.making || 0);
      }

      return {
        ...v,
        finalPrice: metalTotal + diamondTotal,
      };
    });
  };

  // --- VARIATION ACTIONS ---
  const handleAddVariation = () => {
    const id = "v-" + Date.now();
    const newVar = createNewVariationObject(id, "New Variation");

    setVariations((prev) => calculateTotal([...prev, newVar]));
    setActiveVarId(id);
    setActiveMetalSizeId(newVar?.metalSizes?.[0]?._uiId || "");
    setActiveDiamondSizeId(newVar?.metalSizes?.[0]?.diamondSizes?.[0]?._uiId || "");
  };

  // --- duplicate variation ---
  const handleDuplicateVariation = (variation) => {
    const newId = "v-" + Date.now();

    const variationCopy = {
      ...variation,
      tempId: newId,
      variationName: `${variation.variationName} (Copy)`,
      colors: variation.colors, // keep original reference
    };

    setVariations((prev) => calculateTotal([...prev, variationCopy]));
    setActiveVarId(newId);
  };

  const handleDeleteVariation = (tempId, e) => {
    e.stopPropagation();

    if (variations.length === 1) {
      alert("At least one variation is required.");
      return;
    }

    const filtered = variations.filter((v) => v.tempId !== tempId);
    setVariations(calculateTotal(filtered));

    if (activeVarId === tempId && filtered.length) {
      setActiveVarId(filtered[0].tempId);
      setActiveMetalSizeId(filtered[0].metalSizes[0]._uiId);
      setActiveDiamondSizeId(
        filtered[0].metalSizes[0]?.diamondSizes[0]?._uiId || "",
      );
    }
  };

  const updateField = (field, value) => {
    setVariations((prev) =>
      prev.map((v) =>
        v.tempId === activeVarId ? { ...v, [field]: value } : v,
      ),
    );
  };

  // Update updateComponent to handle rate changes and recalculate totals
  const updateComponent = (type, index, field, value) => {
    setVariations((prev) =>
      calculateTotal(
        prev.map((v) => {
          if (v.tempId !== activeVarId) return v;

          return {
            ...v,
            metalSizes: v.metalSizes.map((m) => {
              if (m._uiId !== activeMetalSizeId) return m;

              // -------- METAL --------
              if (type === "metal") {
                const updatedComponents = m.metalComponents.map((row, i) => {
                  if (i !== index) return row;

                  const updatedRow = {
                    ...row,
                    [field]: isNaN(value) ? value : Number(value),
                  };

                  const { rate, cost } = calculateMetalPriceFrontend(
                    updatedRow,
                    metalRates,
                  );

                  return { ...updatedRow, rate, cost };
                });

                return { ...m, metalComponents: updatedComponents };
              }

              // -------- DIAMOND --------
              return {
                ...m,
                diamondSizes: m.diamondSizes.map((ds) => {
                  if (ds._uiId !== activeDiamondSizeId) return ds;

                  return {
                    ...ds,
                    diamondComponents: ds.diamondComponents.map((row, i) => {
                      if (i !== index) return row;
                      const updatedRow = {
                        ...row,
                        [field]: isNaN(value) ? value : Number(value),
                      };
                      const shape = updatedRow.shape?.toLowerCase().trim();

                      if (shape) {
                        const calc = calculateRoundDiamondFrontend(updatedRow);

                        if (calc) {
                          updatedRow.avgCaratPerStone = calc.avgCaratPerStone;
                          updatedRow.totalCrt = calc.totalCrt;
                          updatedRow.qualityVariants = calc.qualityVariants;
                        }
                      }

                      return updatedRow;
                    }),
                  };
                }),
              };
            }),
          };
        }),
      ),
    );
  };

  // --- SIZE CRUD ACTIONS ---
  const handleDuplicateSize = (type, sizeObj) => {
    const newId = `${type === "metal" ? "m-" : "d-"}${crypto.randomUUID()}`;

    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== activeVarId) return v;

        // -------- METAL SIZE DUPLICATE --------
        if (type === "metal") {
          return {
            ...v,
            metalSizes: [
              ...v.metalSizes,
              {
                ...JSON.parse(JSON.stringify(sizeObj)),
                _uiId: newId,
                sizeLabel: sizeObj.sizeLabel + " (Copy)",
              },
            ],
          };
        }

        // -------- DIAMOND SIZE DUPLICATE --------
        return {
          ...v,
          metalSizes: v.metalSizes.map((m) =>
            m._uiId === activeMetalSizeId
              ? {
                  ...m,
                  diamondSizes: [
                    ...m.diamondSizes,
                    {
                      ...JSON.parse(JSON.stringify(sizeObj)),
                      _uiId: newId,
                      sizeLabel: sizeObj.sizeLabel + " (Copy)",
                    },
                  ],
                }
              : m,
          ),
        };
      }),
    );
  };

  const handleDeleteSize = (type, sizeId, e) => {
    e.stopPropagation();

    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== activeVarId) return v;

        if (type === "metal") {
          const filtered = v.metalSizes.filter((s) => s._uiId !== sizeId);
          return { ...v, metalSizes: filtered };
        }

        return {
          ...v,
          metalSizes: v.metalSizes.map((m) =>
            m._uiId === activeMetalSizeId
              ? {
                  ...m,
                  diamondSizes: m.diamondSizes.filter(
                    (d) => d._uiId !== sizeId,
                  ),
                }
              : m,
          ),
        };
      }),
    );
  };

  // --- SIZE MODAL STATE ---
  const [sizeModal, setSizeModal] = useState({
    show: false,
    typeName: "metal", // 'metal' or 'diamond'
    mode: "add", // 'add' or 'edit'
    id: null, // For editing
    value: "",
  });

  // --- UPDATED SIZE CRUD ACTIONS (Replacing Alerts/Prompts) ---
  const openSizeModal = (type, mode, id = null, initialValue = "") => {
    setSizeModal({ show: true, type, mode, id, value: initialValue });
  };

  const updateMetalSizeField = (metalSizeId, field, value) => {
    setVariations((prev) =>
      prev.map((v) =>
        v.tempId === activeVarId
          ? {
              ...v,
              metalSizes: v.metalSizes.map((m) =>
                m._uiId === metalSizeId ? { ...m, [field]: value } : m,
              ),
            }
          : v,
      ),
    );
  };

  const handleSaveSize = () => {
    const { type, mode, id, value } = sizeModal;
    if (!value?.trim()) return;

    // ---------- ADD MODE ----------
    if (mode === "add") {
      const newUiId = `${type === "metal" ? "m-" : "d-"}${crypto.randomUUID()}`;

      setVariations((prev) =>
        prev.map((v) => {
          if (v.tempId !== activeVarId) return v;

          // -------- ADD METAL SIZE --------
          if (type === "metal") {
            return {
              ...v,
              metalSizes: [
                ...v.metalSizes,
                {
                  _uiId: newUiId,
                  sizeLabel: value,
                  active: true,
                  metalComponents: [
                    {
                      metalType: "Gold",
                      purity: "18k",
                      size: value,
                      weight: 0,
                      rate: 0,
                    },
                  ],
                  metalCharges: { labour: 0, making: 0 },
                  diamondInvolved: false,
                  diamondSizes: [
                    {
                      _uiId: "d-" + crypto.randomUUID(),
                      sizeLabel: "0.5",
                      active: true,
                      diamondComponents: [],
                      diamondCharges: { labour: 0, making: 0 },
                    },
                  ],
                },
              ],
            };
          }

          // -------- ADD DIAMOND SIZE (INSIDE ACTIVE METAL SIZE) --------
          return {
            ...v,
            metalSizes: v.metalSizes.map((m) =>
              m._uiId === activeMetalSizeId
                ? {
                    ...m,
                    diamondSizes: [
                      ...m.diamondSizes,
                      {
                        _uiId: newUiId,
                        sizeLabel: value,
                        active: true,
                        diamondComponents: [],
                        diamondCharges: { labour: 0, making: 0 },
                      },
                    ],
                  }
                : m,
            ),
          };
        }),
      );

      // set active tab
      if (type === "metal") setActiveMetalSizeId(newUiId);
      else setActiveDiamondSizeId(newUiId);
    }

    // ---------- EDIT MODE ----------
    if (mode === "edit") {
      setVariations((prev) =>
        prev.map((v) => {
          if (v.tempId !== activeVarId) return v;

          // -------- RENAME METAL SIZE --------
          if (type === "metal") {
            return {
              ...v,
              metalSizes: v.metalSizes.map((m) =>
                m._uiId === id ? { ...m, sizeLabel: value } : m,
              ),
            };
          }

          // -------- RENAME DIAMOND SIZE --------
          return {
            ...v,
            metalSizes: v.metalSizes.map((m) =>
              m._uiId === activeMetalSizeId
                ? {
                    ...m,
                    diamondSizes: m.diamondSizes.map((d) =>
                      d._uiId === id ? { ...d, sizeLabel: value } : d,
                    ),
                  }
                : m,
            ),
          };
        }),
      );
    }

    // ---------- CLOSE MODAL ----------
    setSizeModal({
      show: false,
      typeName: "metal",
      mode: "add",
      id: null,
      value: "",
    });
  };

  // --- COMPONENT ROW ACTIONS ---
  const handleAddComponentRow = (type) => {
    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== activeVarId) return v;

        return {
          ...v,
          metalSizes: v.metalSizes.map((m) => {
            if (m._uiId !== activeMetalSizeId) return m;

            if (type === "metal") {
              return {
                ...m,
                metalComponents: [
                  ...m.metalComponents,
                  {
                    metalType: "Gold",
                    purity: "18k",
                    size: m.sizeLabel,
                    weight: 0,
                    rate: 0,
                  },
                ],
              };
            }

            return {
              ...m,
              diamondSizes: m.diamondSizes.map((d) =>
                d._uiId === activeDiamondSizeId
                  ? {
                      ...d,
                      diamondComponents: [
                        ...d.diamondComponents,
                        {
                          typeName: "Diamond",
                          shape: "",
                          mmSize: 0,
                          stones: 0,
                        },
                      ],
                    }
                  : d,
              ),
            };
          }),
        };
      }),
    );
  };

  const handleDeleteComponentRow = (type, index) => {
    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== activeVarId) return v;

        return {
          ...v,
          metalSizes: v.metalSizes.map((m) => {
            if (m._uiId !== activeMetalSizeId) return m;

            if (type === "metal") {
              return {
                ...m,
                metalComponents: m.metalComponents.filter(
                  (_, i) => i !== index,
                ),
              };
            }

            return {
              ...m,
              diamondSizes: m.diamondSizes.map((d) =>
                d._uiId === activeDiamondSizeId
                  ? {
                      ...d,
                      diamondComponents: d.diamondComponents.filter(
                        (_, i) => i !== index,
                      ),
                    }
                  : d,
              ),
            };
          }),
        };
      }),
    );
  };

  const updateSizeField = (type, field, value) => {
    setVariations((prev) =>
      prev.map((v) => {
        if (v.tempId !== activeVarId) return v;

        return {
          ...v,
          metalSizes: v.metalSizes.map((m) => {
            if (m._uiId !== activeMetalSizeId) return m;

            if (type === "metal") {
              return {
                ...m,
                metalCharges: {
                  ...m.metalCharges,
                  [field]: Number(value),
                },
              };
            }

            return {
              ...m,
              diamondSizes: m.diamondSizes.map((d) =>
                d._uiId === activeDiamondSizeId
                  ? {
                      ...d,
                      diamondCharges: {
                        ...d.diamondCharges,
                        [field]: Number(value),
                      },
                    }
                  : d,
              ),
            };
          }),
        };
      }),
    );
  };

  useEffect(() => {
    Modal.setAppElement(document.body); // Set the appElement to document.body
  }, []);

  function buildVariationPayload(v) {
    return {
      variationName: v.variationName,
      variationStock: v.variationStock,
      metalSizes: v.metalSizes.map((m) => ({
        _uiId: m._uiId,
        sizeLabel: m.sizeLabel,
        active: m.active,
        metalComponents: m.metalComponents,
        metalCharges: m.metalCharges,
        diamondInvolved: m.diamondInvolved,

        diamondSizes: m.diamondSizes.map((ds) => ({
          _uiId: ds._uiId,
          sizeLabel: ds.sizeLabel,
          active: ds.active,
          diamondCharges: ds.diamondCharges,

          diamondComponents: ds.diamondComponents.map((dc) => ({
            typeName: dc.typeName,
            shape: dc.shape,
            sieveSize: dc.sieveSize,
            mmSize: dc.mmSize,
            stones: dc.stones,
            manualPrice: Number(dc.manualPrice || 0),

            qualityVariants: dc.qualityVariants.map((qv) => ({
              quality: qv.quality,
              active: qv.active,

              // ✅ FORCE OBJECTS ONLY
              otherTypes: Array.isArray(qv.otherTypes)
                ? qv.otherTypes.map((o) => ({
                    typeName: o.typeName,
                    mmSize: Number(o.mmSize),
                    stones: Number(o.stones),
                    price: Number(o.price),
                    labour: Number(o.labour),
                    making: Number(o.making),
                  }))
                : [],
            })),
          })),
        })),
      })),
      existingColors: v.existingColors,
    };
  }

  const isValidDiamond = (diamondSizes = []) => {
    return diamondSizes.every((size) =>
      size.diamondComponents?.every(
        (d) =>
          d.shape &&
          Number(d.mmSize) > 0 &&
          Number(d.stones) > 0 &&
          d.qualityVariants?.length > 0,
      ),
    );
  };

  const isValidMetal = (metalSizes = []) => {
    return metalSizes.every((size) =>
      size.metalComponents?.every(
        (m) =>
          m.metalType && m.purity && Number(m.weight) > 0 && size.sizeLabel,
      ),
    );
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔹 PRODUCT VALIDATION
    if (!productName.trim()) {
      return alert("Product name is required");
    }

    if (!productImages || productImages.length === 0) {
      return alert("Please add at least one product image");
    }

    if (!variations || variations.length === 0) {
      return alert("Please add at least one metal component for this product.");
    }

    // 🔹 VARIATION VALIDATION
    for (const v of variations) {
      if (!v.variationName) {
        return alert("Metal name is required");
      }

      if (!isValidMetal(v.metalSizes)) {
        return alert(
          `Please check metal details in variation "${v.variationName}". 
Each size must have:
- Size label
- Metal type
- Purity
- Weight greater than 0`,
        );
      }

      for (const m of v.metalSizes) {
        if (m.diamondInvolved && !isValidDiamond(m.diamondSizes)) {
          return alert(
            `Invalid diamond details in variation "${v.variationName}", size "${m.sizeLabel}"`,
          );
        }
      }
    }

    setLoading(true);

    // 🔹 IF ALL VALID → PROCEED
    try {
      const formData = new FormData();
      formData.append("Product_Name", productName);

      productImages.forEach((img) => {
        formData.append("images", img);
      });

      formData.append("Category", selectedCategories.value);
      if (selectedBrand?.dataId)
        formData.append("Brand_Name", selectedBrand.dataId);

      formData.append("Collection_Name", selectedCollection?.dataId);
      formData.append("Description", description);

      const response = await axios.post(`${url}/product/add`, formData, {
        headers: { Authorization: adminToken },
      });

      const productId = response?.data?.data?.productId;
      if (!productId) throw new Error("Product ID missing");

      // 🔹 CREATE VARIATIONS
      for (const v of variations) {
        try {
          const payload = buildVariationPayload(v);
          const fd = new FormData();

          fd.append("variationName", payload.variationName);
          fd.append("variationStock", payload.variationStock);
          fd.append("metalSizes", JSON.stringify(payload.metalSizes));
          fd.append("existingColors", JSON.stringify(payload.existingColors));

          v.colors.forEach((group, colorIndex) => {
            group.images.forEach((img) => {
              fd.append("images", img);
            });
          });

          fd.append(
            "colorsMeta",
            JSON.stringify(
              v.colors.map((g, index) => ({
                color: g.color,
                count: g.images.length,
              })),
            ),
          );

          await axios.post(`${url}/product/variation/add/${productId}`, fd, {
            headers: { Authorization: adminToken },
          });
        } catch (error) {
          console.log("error ==> ", error);
        }
      }

      Navigate("/showProduct");
    } catch (err) {
      console.error(err);
      alert("Failed to add product");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setProductAddStatus("");
      setStatusMessage("");
      let alertBox = document?.getElementById("alert-box");
      alertBox?.classList?.remove("alert-wrapper");
    }, 1500);

    return () => clearTimeout(timer);
  }, [productAddStatus, statusMessage]);

  useEffect(() => {
    // Fetch category data from your API
    async function fetchCategoryData() {
      try {
        const response = await axios.get(`${url}/category/get`, {
          headers: {
            Authorization: `${adminToken}`,
          },
        });

        const options = response?.data?.category?.map((option) => ({
          value: option._id,
          label:
            option.Category_Name.charAt(0).toUpperCase() +
            option.Category_Name.slice(1),
        }));

        setCategoryOptions(options);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    }
    fetchCategoryData();
  }, []);

  const handleCategoryChange = (selectedOptions) => {
    setSelectedCategories(selectedOptions);
  };

  // get all brand , collections
  useEffect(() => {
    async function fetchData() {
      try {
        const Response = await axios.get(`${url}/data/get`, {
          headers: {
            Authorization: `${adminToken}`,
          },
        });
        setData(Response?.data?.data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    }
    fetchData();
  }, []);

  // Filter data for each data type
  const brandData = data?.filter((option) => option?.Data_Type === "Brand");
  const collectionsData = data?.filter(
    (option) => option?.Data_Type === "Collection",
  );

  const brandOptions = brandData?.map((option) => {
    return {
      dataId: option?._id,
      label:
        option?.Data_Name?.charAt(0)?.toUpperCase() +
        option?.Data_Name?.slice(1),
    };
  });

  const collectionOptions = collectionsData?.map((option) => {
    return {
      dataId: option?._id,
      label:
        option?.Data_Name?.charAt(0)?.toUpperCase() +
        option?.Data_Name?.slice(1),
    };
  });

  // custom style for react quill
  const customStyles = {
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "white" : "white",
      color: state.isSelected ? "black" : "black",
      ":hover": {
        backgroundColor: "#e6f7ff",
      },
    }),
  };

  //  for react quill (long desc)
  const editor = useRef();

  const handleTextChange = (value) => {
    setDescription(value);
  };

  const tableOptions = [];
  const maxRows = 8;
  const maxCols = 5;
  for (let r = 1; r <= maxRows; r++) {
    for (let c = 1; c <= maxCols; c++) {
      tableOptions.push("newtable_" + r + "_" + c);
    }
  }

  const editorModules = {
    toolbar: [
      [
        { header: "1" },
        { header: "2" },
        { header: [3, 4, 5, 6] },
        { font: [] },
      ],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "video", "image"],
      ["clean"],
      ["code-block"],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }, { table: tableOptions }],
    ],
  };

  // -------- QUALITY OTHER TYPE MODAL --------
  const [qualityModal, setQualityModal] = useState({
    show: false,
    varId: null,
    metalSizeId: null,
    diamondSizeId: null,
    diamondIndex: null,
    qualityIndex: null,
    quality: null,
  });

  const [otherTypesDraft, setOtherTypesDraft] = useState([]);

  const updateOtherTypeRow = (index, field, value) => {
    setOtherTypesDraft((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)),
    );
  };

  const addOtherTypeRow = () => {
    setOtherTypesDraft((prev) => [
      ...prev,
      {
        typeName: "",
        mmSize: "",
        stones: "",
        price: "",
        labour: "",
        making: "",
      },
    ]);
  };

  const removeOtherTypeRow = (index) => {
    setOtherTypesDraft((prev) => prev.filter((_, i) => i !== index));
  };

  const saveOtherTypeToQuality = () => {
    setVariations((prev) =>
      calculateTotal(
        prev.map((v) => {
          if (v.tempId !== qualityModal.varId) return v;
          return {
            ...v,
            metalSizes: v.metalSizes.map((m) =>
              m._uiId !== qualityModal.metalSizeId
                ? m
                : {
                    ...m,
                    diamondSizes: m.diamondSizes.map((ds) =>
                      ds._uiId !== qualityModal.diamondSizeId
                        ? ds
                        : {
                            ...ds,
                            diamondComponents: ds.diamondComponents.map(
                              (dc, dIdx) => {
                                if (dIdx !== qualityModal.diamondIndex)
                                  return dc;
                                return {
                                  ...dc,
                                  qualityVariants: dc.qualityVariants.map(
                                    (qv, qIdx) => {
                                      if (qIdx !== qualityModal.qualityIndex)
                                        return qv;

                                      return {
                                        ...qv,
                                        otherTypes: otherTypesDraft.map(
                                          (o) => ({
                                            typeName: o.typeName,
                                            mmSize: Number(o.mmSize),
                                            stones: Number(o.stones),
                                            price: Number(o.price),
                                            labour: Number(o.labour),
                                            making: Number(o.making),
                                          }),
                                        ),
                                      };
                                    },
                                  ),
                                };
                              },
                            ),
                          },
                    ),
                  },
            ),
          };
        }),
      ),
    );

    // reset
    setQualityModal({ show: false });
    setOtherTypesDraft([]);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Add Product</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Product Name:
                        </label>
                        <div className="col-md-10">
                          <input
                            required
                            className="form-control"
                            type="text"
                            id="example-text-input"
                            value={productName}
                            onChange={(e) => {
                              setProductName(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Category Name:
                        </label>
                        <div className="col-md-10">
                          <Select
                            name="categories"
                            value={selectedCategories}
                            onChange={handleCategoryChange}
                            options={categoryOptions}
                            placeholder="Select Categories"
                            className="w-full md:w-20rem"
                          />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Brand Name:
                        </label>
                        <div className="col-md-10">
                          <Select
                            name="brands"
                            value={selectedBrand}
                            onChange={(e) => setSelectedBrand(e)}
                            options={brandOptions}
                            styles={customStyles}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Collection :
                        </label>
                        <div className="col-md-10">
                          <Select
                            name="collections"
                            value={selectedCollection}
                            onChange={(e) => setSelectedCollection(e)}
                            options={collectionOptions}
                            styles={customStyles}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Long Description:
                        </label>
                        <div className="col-md-10">
                          <ReactQuill
                            ref={editor}
                            value={description}
                            onChange={handleTextChange}
                            modules={editorModules}
                            className="custom-quill-editor"
                          />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Product Images:
                          <div className="imageSize">
                            (Recommended Resolution: W-971 X H-1500, W-1295 X
                            H-2000, W-1618 X H-2500)
                          </div>
                        </label>
                        <div className="col-md-10">
                          <input
                            required
                            className="form-control"
                            type="file"
                            multiple
                            onChange={(e) => {
                              setProductImages([...e.target.files]);
                            }}
                            id="example-text-input"
                          />
                          <div
                            className="fileupload_img col-md-10 mt-3"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            {productImages.length > 0 ? (
                              productImages?.map((img, i) => (
                                <img
                                  key={i}
                                  src={URL.createObjectURL(img)}
                                  alt="product"
                                  height={100}
                                  style={{ objectFit: "cover", width: "auto" }}
                                />
                              ))
                            ) : (
                              <img
                                src={defualtImage}
                                height={100}
                                width={100}
                                alt="default"
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div>
                        {/* 2. VARIATIONS CARD */}
                        <div className="card shadow-sm border-0 mb-4">
                          <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                            <h5 className="mb-0 text-primary fw-bold">
                              <Briefcase className="me-2" />
                              Metal Options
                            </h5>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={handleAddVariation}
                            >
                              <Plus size={16} className="me-1" /> Add Metal
                              Options
                            </button>
                          </div>

                          {/* VARIATION TABS */}
                          <div className="p-3 bg-white border-bottom">
                            <ul className="nav nav-tabs border-0">
                              {variations?.map((v, i) => (
                                <li className="nav-item" key={i}>
                                  <div
                                    className={`mb-2 nav-link fw-bold d-flex align-items-center gap-2 ${activeVarId === v.tempId ? "active bg-primary text-white shadow-sm" : "text-secondary bg-light"}`}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "5px",
                                      borderRadius: "8px 8px 0 0",
                                    }}
                                    onClick={() => {
                                      setActiveVarId(v.tempId);
                                      setActiveMetalSizeId(
                                        v.metalSizes[0]?._uiId || "",
                                      );
                                      setActiveDiamondSizeId(
                                        v.metalSizes[0]?.diamondSizes?.[0]
                                          ?._uiId || "",
                                      );
                                    }}
                                  >
                                    {v.variationName}
                                    <div className="d-flex gap-1 ms-2">
                                      <Copy
                                        size={14}
                                        className={
                                          activeVarId === v.tempId
                                            ? "text-white-50"
                                            : "text-primary"
                                        }
                                        onClick={(e) =>
                                          handleDuplicateVariation(v, e)
                                        }
                                      />
                                      <Trash2
                                        size={14}
                                        className={
                                          activeVarId === v.tempId
                                            ? "text-white-50"
                                            : "text-danger"
                                        }
                                        onClick={(e) =>
                                          handleDeleteVariation(v.tempId, e)
                                        }
                                      />
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-end mb-4">
                              <div className="w-50">
                                <label className="form-label small fw-bold">
                                  Metal Display Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={currentVar.variationName}
                                  onChange={(e) =>
                                    updateField("variationName", e.target.value)
                                  }
                                />
                              </div>
                              <button
                                type="button"
                                className="btn btn-outline-primary shadow-sm d-flex align-items-center gap-2"
                                onClick={() => {
                                  setColorModal(true);
                                }}
                              >
                                <ImageIcon size={18} /> Add Color (
                                {currentVar.colors.length})
                              </button>
                            </div>

                            <div>
                              <label className="form-label small fw-bold my-2">
                                Added Colors
                              </label>
                              <div className="d-flex flex-row gap-3 my-3 flex-wrap">
                                {[
                                  ...(currentVar.existingColors || []),
                                  ...(currentVar.colors || []),
                                ].map((group, i) => (
                                  <div
                                    key={i}
                                    className="p-3 border rounded bg-light shadow-sm"
                                    style={{ minWidth: "200px" }}
                                  >
                                    {/* Color Label & Group Actions */}
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                      <div className="d-flex align-items-center">
                                        <span className="badge rounded-pill bg-dark px-3 py-2 text-uppercase">
                                          {group.color}
                                        </span>
                                        <small className="ms-2 text-muted">
                                          {group.images?.length || 0} Images
                                        </small>
                                      </div>

                                      {/* Group Level Edit/Delete */}
                                      <div className="btn-group btn-group-sm">
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setEditMode(true);
                                            setEditingGroupIndex(i);
                                            setEditingGroupSource(
                                              currentVar.existingColors?.includes(
                                                group,
                                              )
                                                ? "existingColors"
                                                : "colors",
                                            );

                                            setUploadColor(group.color);

                                            // preload images
                                            if (
                                              group.images?.[0] instanceof File
                                            ) {
                                              setTempUploadedImages([
                                                {
                                                  color: group.color,
                                                  images: group.images,
                                                },
                                              ]);
                                              setTempSelectedImages([]);
                                            } else {
                                              setTempSelectedImages(
                                                group.images,
                                              );
                                              setTempUploadedImages([]);
                                            }

                                            setColorModal(true);
                                          }}
                                          className="btn btn-primary px-2  mx-2 d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                          title="Edit Group"
                                        >
                                          <Pencil size={12} />
                                        </button>
                                        <button
                                          onClick={() => {
                                            if (
                                              alert(
                                                `Delete ${group.color} color group?`,
                                              )
                                            )
                                              return;

                                            deleteColorGroup(
                                              currentVar.tempId,
                                              i,
                                              currentVar.existingColors?.includes(
                                                group,
                                              )
                                                ? "existingColors"
                                                : "colors",
                                            );
                                          }}
                                          className="btn btn-danger px-2  d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                          title="Delete Group"
                                        >
                                          <Trash2 size={12} />
                                        </button>
                                      </div>
                                    </div>

                                    {/* Image Grid */}
                                    <div className="d-flex gap-2 flex-wrap">
                                      {group.images?.map((img, idx) => {
                                        const imgSrc = img.url
                                          ? img.url
                                          : img instanceof File
                                            ? URL.createObjectURL(img)
                                            : `${url}/${img.path}`;

                                        return (
                                          <div
                                            key={idx}
                                            className="position-relative group-image-container"
                                          >
                                            <img
                                              src={imgSrc}
                                              alt={`${group.color}-${idx}`}
                                              style={{
                                                width: "65px",
                                                height: "65px",
                                                objectFit: "cover",
                                              }}
                                              className="rounded border bg-white shadow-sm img-thumbnail"
                                            />

                                            {/* Individual Image Delete Icon (Top Right) */}
                                            <button
                                              className="position-absolute top-0 end-0 btn btn-danger p-0 d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                fontSize: "12px",
                                                marginTop: "-5px",
                                                marginRight: "-5px",
                                              }}
                                              onClick={() =>
                                                deleteSingleImage(
                                                  currentVar.tempId,
                                                  i,
                                                  idx,
                                                  currentVar.existingColors?.includes(
                                                    group,
                                                  )
                                                    ? "existingColors"
                                                    : "colors",
                                                )
                                              }
                                            >
                                              <X />
                                            </button>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* METAL SECTION */}
                            <div className="mb-5">
                              <div className="d-flex align-items-center gap-3 mb-3">
                                <h6 className="fw-bold mb-0 text-dark">
                                  <Layers
                                    size={18}
                                    className="me-2 text-muted"
                                  />
                                  Item Sizes
                                </h6>
                              </div>
                              <div className="d-flex flex-wrap align-items-center gap-2 bg-light p-2 rounded border mb-3">
                                {currentVar.metalSizes?.map((s, i) => (
                                  <div
                                    key={i}
                                    className={`btn-group btn-group-sm shadow-sm ${activeMetalSizeId === s._uiId ? "ring-primary" : ""}`}
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${activeMetalSizeId === s._uiId ? "btn-dark" : "btn-white border"}`}
                                      onClick={() =>
                                        setActiveMetalSizeId(s._uiId)
                                      }
                                    >
                                      {s.sizeLabel}
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-white border dropdown-toggle dropdown-toggle-split"
                                      data-bs-toggle="dropdown"
                                    >
                                      <EllipsisVertical size={12} />
                                    </button>
                                    <ul className="dropdown-menu shadow-sm">
                                      <li>
                                        <button
                                          type="button"
                                          className="dropdown-item small"
                                          onClick={() =>
                                            openSizeModal(
                                              "metal",
                                              "edit",
                                              s._uiId,
                                              s.sizeLabel,
                                            )
                                          }
                                        >
                                          Edit Name
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          type="button"
                                          className="dropdown-item small"
                                          onClick={() =>
                                            handleDuplicateSize("metal", s)
                                          }
                                        >
                                          Duplicate
                                        </button>
                                      </li>
                                      <li>
                                        <hr className="dropdown-divider" />
                                      </li>
                                      <li>
                                        <button
                                          type="button"
                                          className="dropdown-item small text-danger"
                                          onClick={(e) =>
                                            handleDeleteSize(
                                              "metal",
                                              s._uiId,
                                              e,
                                            )
                                          }
                                        >
                                          Delete
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="btn btn-outline-success btn-sm rounded-circle p-2 d-flex align-items-center justify-content-center"
                                  onClick={() => openSizeModal("metal", "add")}
                                >
                                  <Plus size={16} />
                                </button>
                              </div>

                              <h6 className="fw-bold mb-10 text-dark">
                                <Layers size={18} className="me-2 text-muted" />
                                Metal Components
                              </h6>

                              {currentVar.metalSizes.length > 0 ? (
                                <table className="table table-bordered align-middle shadow-sm">
                                  {/* The 'table-striped' class is omitted to keep all rows the same color */}
                                  <thead className="table-light small text-uppercase">
                                    <tr>
                                      <th>
                                        Metal Type{" "}
                                        <div className="d-flex gap-2 mt-1">
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Add Metal Type"
                                            value={metalTypeInput}
                                            onChange={(e) =>
                                              setMetalTypeInput(e.target.value)
                                            }
                                          />
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={() => {
                                              if (!metalTypeInput.trim())
                                                return;

                                              // prevent duplicates
                                              if (
                                                metalTypes.includes(
                                                  metalTypeInput,
                                                )
                                              )
                                                return;

                                              setMetalTypes((prev) => [
                                                ...prev,
                                                metalTypeInput,
                                              ]);
                                              setMetalTypeInput("");
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </th>
                                      <th>
                                        Purity{" "}
                                        <div className="d-flex gap-2 mt-1">
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Add Purity"
                                            value={metalPurityInput}
                                            onChange={(e) =>
                                              setMetalPurityInput(
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={() => {
                                              if (!metalPurityInput.trim())
                                                return;

                                              // prevent duplicates
                                              if (
                                                purities.includes(
                                                  metalPurityInput,
                                                )
                                              )
                                                return;

                                              setPurities((prev) => [
                                                ...prev,
                                                metalPurityInput,
                                              ]);
                                              setMetalPurityInput("");
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </th>

                                      <th>
                                        Size / Length
                                        <div className="d-flex gap-2 mt-1">
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Add size"
                                            value={metalSizeInput}
                                            onChange={(e) =>
                                              setMetalSizeInput(e.target.value)
                                            }
                                          />
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={() => {
                                              if (!metalSizeInput.trim())
                                                return;

                                              // prevent duplicates
                                              if (
                                                metalSizesList.includes(
                                                  metalSizeInput,
                                                )
                                              )
                                                return;

                                              setMetalSizesList((prev) => [
                                                ...prev,
                                                metalSizeInput,
                                              ]);
                                              setMetalSizeInput("");
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </th>

                                      <th>Weight (g)</th>
                                      <th>Rate/g</th>
                                      <th className="text-end">Cost</th>
                                      <th
                                        className="text-center"
                                        style={{ width: "50px" }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="bg-white">
                                    {currentMetalSize?.metalComponents?.map(
                                      (m, idx) => (
                                        <tr key={idx}>
                                          <td>
                                            <select
                                              className="form-select form-select-sm"
                                              value={m.metalType}
                                              onChange={(e) =>
                                                updateComponent(
                                                  "metal",
                                                  idx,
                                                  "metalType",
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              {metalTypes?.map((o) => (
                                                <option key={o}>{o}</option>
                                              ))}
                                            </select>
                                          </td>
                                          <td>
                                            <select
                                              className="form-select form-select-sm"
                                              value={m.purity}
                                              onChange={(e) =>
                                                updateComponent(
                                                  "metal",
                                                  idx,
                                                  "purity",
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              {purities?.map((o) => (
                                                <option key={o}>{o}</option>
                                              ))}
                                            </select>
                                          </td>
                                          <td>
                                            <select
                                              className="form-select form-select-sm"
                                              value={m.size}
                                              onChange={(e) =>
                                                updateComponent(
                                                  "metal",
                                                  idx,
                                                  "size",
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              {metalSizesList?.map((o) => (
                                                <option key={o}>{o}</option>
                                              ))}
                                            </select>
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              className="form-control form-control-sm"
                                              value={m.weight}
                                              onChange={(e) =>
                                                updateComponent(
                                                  "metal",
                                                  idx,
                                                  "weight",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>
                                          <td>
                                            <span className="fw-bold">
                                              ${m.rate}
                                            </span>
                                          </td>
                                          <td className="text-end fw-bold">
                                            $
                                            {(
                                              Number(m.weight || 0) *
                                              Number(m.rate || 0)
                                            ).toFixed(2)}
                                          </td>
                                          <td className="text-center">
                                            <button
                                              type="button"
                                              className="btn btn-outline-danger btn-sm border-0"
                                              onClick={() =>
                                                handleDeleteComponentRow(
                                                  "metal",
                                                  idx,
                                                )
                                              }
                                            >
                                              <Trash2 size={16} />
                                            </button>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                  <tfoot>
                                    {/* ADD NEW ROW SECTION */}
                                    <tr>
                                      <td
                                        colSpan="7"
                                        className="p-2 border-0 bg-white"
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-link btn-sm text-decoration-none fw-bold p-0"
                                          style={{ color: "#ff4d4d" }}
                                          onClick={() =>
                                            handleAddComponentRow("metal")
                                          }
                                        >
                                          + Add new
                                        </button>
                                      </td>
                                    </tr>

                                    {/* subTotal Cost */}
                                    <tr>
                                      <td
                                        colSpan="5"
                                        className="text-end fw-bold border bg-light py-2"
                                      >
                                        Sub-total Cost
                                      </td>
                                      <td className="text-end fw-bold bg-light">
                                        $
                                        {currentMetalSize?.metalComponents
                                          ?.reduce(
                                            (acc, m) =>
                                              acc +
                                              Number(m.weight || 0) *
                                                Number(m.rate || 0),
                                            0,
                                          )
                                          .toFixed(2)}
                                      </td>
                                    </tr>

                                    {/* making labour CHARGE */}
                                    <tr>
                                      <td
                                        colSpan="5"
                                        className="text-end fw-bold border bg-light py-2"
                                      >
                                        Making
                                      </td>
                                      <td className="text-end fw-bold bg-light">
                                        <input
                                          type="number"
                                          className="form-control form-control-sm border-0 text-end py-2"
                                          value={
                                            currentMetalSize?.metalCharges
                                              ?.labour
                                          }
                                          onChange={(e) =>
                                            updateSizeField(
                                              "metal",
                                              "labour",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>

                                    {/* profit MAKING CHARGE */}
                                    <tr>
                                      <td
                                        colSpan={"5"}
                                        className="text-end fw-bold border bg-light py-2"
                                      >
                                        Profit
                                      </td>
                                      <td className="text-end fw-bold bg-light">
                                        <input
                                          type="number"
                                          className="form-control form-control-sm border-0 text-end py-2"
                                          value={
                                            currentMetalSize?.metalCharges
                                              ?.making
                                          }
                                          onChange={(e) =>
                                            updateSizeField(
                                              "metal",
                                              "making",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>

                                    {/* FINAL TOTAL COST */}
                                    <tr>
                                      <td
                                        colSpan={"5"}
                                        className="text-end fw-bold border bg-light py-2"
                                      >
                                        Total Cost
                                      </td>
                                      <td className="text-end fw-bold bg-light">
                                        ${MetalTotalCost().toFixed(2)}
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              ) : (
                                <>
                                  <p className="text-muted">
                                    Please add a metal size or label tab to
                                    manage its components.
                                  </p>
                                </>
                              )}
                            </div>

                            {/* DIAMOND SECTION */}
                            <div
                              className="form-check form-switch mb-4 p-3 rounded border"
                              style={{ backgroundColor: "#f0f7ff" }}
                            >
                              <input
                                className="form-check-input ms-0 me-2"
                                type="checkbox"
                                checked={currentMetalSize.diamondInvolved}
                                onChange={(e) =>
                                  updateMetalSizeField(
                                    activeMetalSizeId,
                                    "diamondInvolved",
                                    e.target.checked,
                                  )
                                }
                              />
                              <label className="form-check-label fw-bold text-primary">
                                Add Stones
                              </label>
                            </div>

                            {currentMetalSize.diamondInvolved && (
                              <div className="animate__animated animate__fadeIn mb-4">
                                <div className="d-flex align-items-center gap-3 mb-3">
                                  <h6 className="fw-bold mb-0 text-info">
                                    <Gem size={18} className="me-2" />
                                    DIAMOND COMPONENTS
                                  </h6>
                                                                  </div>

                              <div className="d-flex flex-wrap align-items-center gap-2 bg-light p-2 rounded border mb-3">
                                    {currentMetalSize.diamondSizes?.map(
                                      (s, i) => (
                                        <div
                                          key={i}
                                          className={`btn-group btn-group-sm shadow-sm`}
                                        >
                                          <button
                                            type="button"
                                            className={`btn ${activeDiamondSizeId === s._uiId ? "btn-info text-white" : "btn-white border text-info"}`}
                                            onClick={() =>
                                              setActiveDiamondSizeId(s._uiId)
                                            }
                                          >
                                            {s.sizeLabel}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-white border dropdown-toggle dropdown-toggle-split text-info"
                                            data-bs-toggle="dropdown"
                                          >
                                            <EllipsisVertical size={12} />
                                          </button>
                                          <ul className="dropdown-menu shadow-sm">
                                            <li>
                                              <button
                                                type="button"
                                                className="dropdown-item small"
                                                onClick={() =>
                                                  openSizeModal(
                                                    "diamond",
                                                    "edit",
                                                    s._uiId,
                                                    s.sizeLabel,
                                                  )
                                                }
                                              >
                                                Edit Name
                                              </button>
                                            </li>
                                            <li>
                                              <button
                                                type="button"
                                                className="dropdown-item small"
                                                onClick={() =>
                                                  handleDuplicateSize(
                                                    "diamond",
                                                    s,
                                                  )
                                                }
                                              >
                                                Duplicate
                                              </button>
                                            </li>
                                            <li>
                                              <hr className="dropdown-divider" />
                                            </li>
                                            <li>
                                              <button
                                                type="button"
                                                className="dropdown-item small text-danger"
                                                onClick={(e) =>
                                                  handleDeleteSize(
                                                    "diamond",
                                                    s._uiId,
                                                    e,
                                                  )
                                                }
                                              >
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </div>
                                      ),
                                    )}
                                    <button
                                      type="button"
                                      className="btn btn-outline-info btn-sm rounded-circle"
                                      onClick={() =>
                                        openSizeModal("diamond", "add")
                                      }
                                    >
                                      <Plus size={16} />
                                    </button>
                                  </div>

                                {currentMetalSize.diamondSizes.length === 0 ? (
                                  <p className="text-muted">
                                    Please add a diamond size or label tab to
                                    manage its components.
                                  </p>
                                ) : (
                                  <>
                                    <table className="table table-bordered align-middle shadow-sm">
                                      <thead className="table-light small text-uppercase">
                                        <tr>
                                          <th>Type</th>
                                          <th>Shape</th>
                                          <th>Size/Length</th>
                                          <th>mm</th>
                                        <th>No. Stones</th>
                                        <th>Average</th>
                                        <th>Total Crt</th>
                                        <th>Manual Price</th>
                                        <th style={{ width: "100px" }}>
                                          Qualities
                                        </th>

                                          {/* <th className="text-end">Cost</th> */}
                                          <th
                                            className="text-center"
                                            style={{ width: "50px" }}
                                          >
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentDiamondSize?.diamondComponents?.map(
                                          (d, idx) => (
                                            <tr key={idx}>
                                              <td style={{ width: "120px" }}>
                                                <input
                                                  className="form-control form-control-sm"
                                                  value={d.typeName}
                                                onChange={(e) =>
                                                  updateComponent(
                                                    "diamond",
                                                    idx,
                                                    "typeName",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>

                                            <td style={{ width: "150px" }}>
                                              <select
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={d.shape}
                                                onChange={(e) =>
                                                  updateComponent(
                                                    "diamond",
                                                    idx,
                                                    "shape",
                                                    e.target.value,
                                                  )
                                                }
                                              >
                                                <option value="">
                                                  Select Shape
                                                </option>
                                                {shapes.map((shape, i) => (
                                                  <option key={i} value={shape}>
                                                    {shape}
                                                  </option>
                                                ))}
                                              </select>
                                            </td>
                                            <td style={{ width: "150px" }}>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={d.sieveSize}
                                                onChange={(e) =>
                                                  updateComponent(
                                                    "diamond",
                                                    idx,
                                                    "sieveSize",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td style={{ width: "120px" }}>
                                              <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                className="form-control form-control-sm"
                                                value={d.mmSize}
                                                onChange={(e) =>
                                                  updateComponent(
                                                    "diamond",
                                                    idx,
                                                    "mmSize",
                                                    parseFloat(
                                                      e.target.value,
                                                    ) || 0,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td style={{ width: "120px" }}>
                                              <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={d.stones}
                                                onChange={(e) =>
                                                  updateComponent(
                                                    "diamond",
                                                    idx,
                                                    "stones",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td style={{ width: "120px" }}>
                                              {d.avgCaratPerStone?.toFixed(4)}
                                            </td>
                                            <td style={{ width: "100px" }}>
                                              {d.totalCrt?.toFixed(3)}
                                            </td>
                                            <td style={{ width: "140px" }}>
                                              <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={getManualPriceValue(d)}
                                                placeholder="Enter price"
                                                readOnly={isManualPriceLocked(d)}
                                                onChange={(e) =>
                                                  updateComponent(
                                                    "diamond",
                                                    idx,
                                                    "manualPrice",
                                                    parseFloat(e.target.value) || 0,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td style={{ width: "500px" }}>
                                              <div className="row g-2">
                                                {d.qualityVariants?.map(
                                                  (q, qIdx) => (
                                                    <div
                                                      className="col-6 cursor-pointer"
                                                      key={qIdx}
                                                      onClick={(e) => {
                                                        e.stopPropagation();

                                                        setQualityModal({
                                                          show: true,
                                                          varId: activeVarId,
                                                          metalSizeId:
                                                            activeMetalSizeId,
                                                          diamondSizeId:
                                                            activeDiamondSizeId,
                                                          diamondIndex: idx,
                                                          qualityIndex: qIdx,
                                                          quality: q,
                                                        });

                                                        if (q.otherTypes) {
                                                          setOtherTypesDraft(
                                                            q.otherTypes?.length
                                                              ? q.otherTypes
                                                              : [
                                                                  {
                                                                    typeName:
                                                                      "",
                                                                    mmSize: "",
                                                                    stones: "",
                                                                    price: "",
                                                                    labour: "",
                                                                    making: "",
                                                                  },
                                                                ],
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <div
                                                        className="border border-light rounded p-2 h-100"
                                                        style={{
                                                          backgroundColor:
                                                            "#fafafa",
                                                        }}
                                                      >
                                                        <strong className="d-block small text-dark">
                                                          {q.quality}
                                                        </strong>

                                                        <small className="text-muted d-block">
                                                          Per Ct: ${" "}
                                                          {q.pricePerCrt}
                                                        </small>
                                                        <small className="fw-semibold d-block text-success">
                                                          Total: $
                                                          {q.otherTypes
                                                            ?.length > 0
                                                            ? calculateQualityPrice(
                                                                q,
                                                              )
                                                            : q.finalPrice}
                                                        </small>
                                                      </div>
                                                    </div>
                                                  ),
                                                )}
                                              </div>
                                            </td>

                                            <td className="text-center">
                                              <button
                                                type="button"
                                                className="btn btn-outline-danger btn-sm border-0"
                                                onClick={() =>
                                                  handleDeleteComponentRow(
                                                    "diamond",
                                                    idx,
                                                  )
                                                }
                                              >
                                                <Trash2 size={16} />
                                              </button>
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                      {/* ADD NEW ROW SECTION */}
                                      <tr>
                                        <td
                                          colSpan="7"
                                          className="p-2 border-0 bg-white"
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-link btn-sm text-decoration-none fw-bold p-0"
                                            style={{ color: "#ff4d4d" }}
                                            onClick={() =>
                                              handleAddComponentRow("diamond")
                                            }
                                          >
                                            + Add new
                                          </button>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>

                                    {qualityTotals && (
                                      <div className="mt-3">
                                        <div className="row g-3">
                                          {[
                                            { key: "lab_vvs_vs", label: "LAB VVS/VS" },
                                            { key: "natural_fg_vs", label: "FG VS" },
                                            { key: "natural_gh_si", label: "GH SI" },
                                            { key: "natural_hi_si", label: "HI SI" },
                                          ].map((q) => (
                                            <div className="col-12 col-md-3" key={q.key}>
                                              <div className="border rounded p-3 h-100 bg-light">
                                                <div className="small text-muted text-uppercase">
                                                  {q.label}
                                                </div>
                                                <div className="fw-bold text-dark">
                                                  ${Number(
                                                    MetalTotalCost() +
                                                      (qualityTotals[q.key] || 0),
                                                  ).toFixed(2)}
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* --- IMAGE MANAGEMENT MODAL --- */}
                        {showColorModal && (
                          <div
                            className="modal d-block"
                            style={{
                              backgroundColor: "rgba(0,0,0,0.5)",
                              zIndex: 1050,
                            }}
                          >
                            <div className="modal-dialog modal-lg modal-dialog-centered">
                              <div className="modal-content border-0 shadow-lg">
                                <div className="modal-header bg-white border-bottom py-3">
                                  <h6 className="modal-title fw-bold">
                                    {editMode ? "Edit Color" : "Add Color"}
                                  </h6>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setColorModal(false)}
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <label className="form-label small fw-bold text-muted text-uppercase">
                                    Color Name
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control w-50 mb-3"
                                    placeholder="Enter Color (White, Rose, Yellow Gold...)"
                                    value={uploadColor}
                                    onChange={(e) =>
                                      setUploadColor(e.target.value)
                                    }
                                  />

                                  <div className="d-flex border-bottom bg-light">
                                    <button
                                      type="button"
                                      className={`flex-fill py-3 border-0 transition-all ${modalTab === "upload" ? "bg-white fw-bold border-bottom border-primary border-3 text-primary" : "text-muted bg-light"}`}
                                      onClick={() => setModalTab("upload")}
                                    >
                                      <Upload size={18} className="me-2" />
                                      Upload New Variation Images
                                    </button>
                                    <button
                                      type="button"
                                      className={`flex-fill py-3 border-0 transition-all ${modalTab === "library" ? "bg-white fw-bold border-bottom border-primary border-3 text-primary" : "text-muted bg-light"}`}
                                      onClick={() => setModalTab("library")}
                                    >
                                      <CheckCircle size={18} className="me-2" />{" "}
                                      Select from Media Library
                                    </button>
                                  </div>

                                  <div
                                    className="p-4"
                                    style={{ minHeight: "300px" }}
                                  >
                                    {modalTab === "upload" ? (
                                      <div className="text-center border-2 border-dashed rounded p-5 bg-light">
                                        <Upload
                                          size={40}
                                          className="text-muted mb-3"
                                        />
                                        <h5>Drag and drop images here</h5>
                                        <p className="text-muted small">
                                          Only JPG, PNG files supported
                                        </p>

                                        <input
                                          type="file"
                                          className="form-control w-50 mx-auto mt-3"
                                          multiple
                                          onChange={(e) => {
                                            const files = Array.from(
                                              e.target.files,
                                            );
                                            const finalColor =
                                              uploadColor.trim() || "Default";

                                            setTempUploadedImages((prev) => {
                                              const existing = prev.find(
                                                (g) => g.color === finalColor,
                                              );

                                              if (existing) {
                                                return prev.map((g) =>
                                                  g.color === finalColor
                                                    ? {
                                                        ...g,
                                                        images: [
                                                          ...g.images,
                                                          ...files,
                                                        ],
                                                      }
                                                    : g,
                                                );
                                              }

                                              return [
                                                ...prev,
                                                {
                                                  color: finalColor,
                                                  images: files,
                                                },
                                              ];
                                            });

                                            e.target.value = null;
                                          }}
                                        />

                                        <div className="d-flex gap-2 mt-3 flex-wrap justify-content-center">
                                          {tempUploadedImages.map(
                                            (group, i) => (
                                              <div
                                                key={i}
                                                className="mb-3 text-center"
                                              >
                                                <strong className="d-block mb-2 text-primary">
                                                  {group.color}
                                                </strong>

                                                <div className="d-flex gap-2 justify-content-center flex-wrap">
                                                  {group.images.map(
                                                    (img, idx) => (
                                                      <div
                                                        key={idx}
                                                        className="position-relative"
                                                      >
                                                        <img
                                                          src={URL.createObjectURL(
                                                            img,
                                                          )}
                                                          height={70}
                                                          className="rounded border"
                                                        />
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                                        >
                                                          ×
                                                        </button>
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        <p className="text-muted small mb-3">
                                          Showing images uploaded in 'General
                                          Product Information'
                                        </p>
                                        <div className="row g-3">
                                          {allProductImages?.map((img, i) => (
                                            <div className="col-3" key={i}>
                                              <div className="position-relative border rounded p-1 hover-shadow cursor-pointer">
                                                <img
                                                  src={img.url}
                                                  alt="prod"
                                                  className="img-fluid rounded"
                                                />
                                                <input
                                                  type="checkbox"
                                                  checked={tempSelectedImages.some(
                                                    (x) =>
                                                      x.filename ===
                                                      img.filename,
                                                  )}
                                                  onChange={(e) => {
                                                    if (e.target.checked) {
                                                      setTempSelectedImages(
                                                        (prev) => [
                                                          ...prev,
                                                          img,
                                                        ],
                                                      );
                                                    } else {
                                                      setTempSelectedImages(
                                                        (prev) =>
                                                          prev.filter(
                                                            (x) =>
                                                              x.filename !==
                                                              img.filename,
                                                          ),
                                                      );
                                                    }
                                                  }}
                                                  className="position-absolute top-0 end-0 m-2 shadow"
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="modal-footer bg-light border-top">
                                  <button
                                    type="button"
                                    className="btn btn-secondary px-4"
                                    onClick={() => {
                                      setColorModal(false);
                                      setEditMode(false);
                                      setEditingGroupIndex(null);
                                      setEditingGroupSource(null);
                                      setTempUploadedImages([]);
                                      setTempSelectedImages([]);
                                      setUploadColor("");
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary px-4 shadow-sm"
                                    onClick={() => {
                                      setVariations((prev) =>
                                        prev.map((v) => {
                                          if (v.tempId !== activeVarId)
                                            return v;
                                          const finalColor =
                                            uploadColor.trim() || "Default";
                                          // group selected library images
                                          const selectedColorGroup =
                                            tempSelectedImages.length
                                              ? [
                                                  {
                                                    color: finalColor,
                                                    images: tempSelectedImages,
                                                  },
                                                ]
                                              : [];

                                          // EDIT MODE
                                          if (editMode) {
                                            const updated = { ...v };

                                            if (
                                              editingGroupSource === "colors"
                                            ) {
                                              updated.colors = v.colors.map(
                                                (g, idx) =>
                                                  idx === editingGroupIndex
                                                    ? {
                                                        color: finalColor,
                                                        images:
                                                          tempUploadedImages[0]
                                                            ?.images ||
                                                          g.images,
                                                      }
                                                    : g,
                                              );
                                            }

                                            if (
                                              editingGroupSource ===
                                              "existingColors"
                                            ) {
                                              updated.existingColors =
                                                v.existingColors.map(
                                                  (g, idx) =>
                                                    idx === editingGroupIndex
                                                      ? {
                                                          color: finalColor,
                                                          images:
                                                            tempSelectedImages,
                                                        }
                                                      : g,
                                                );
                                            }

                                            return updated;
                                          }

                                          return {
                                            ...v,
                                            colors: [
                                              ...(v.colors || []),
                                              ...tempUploadedImages.map(
                                                (g) => ({
                                                  color: g.color,
                                                  images: g.images,
                                                }),
                                              ),
                                            ],
                                            existingColors: [
                                              ...(v.existingColors || []),
                                              ...selectedColorGroup,
                                            ],
                                          };
                                        }),
                                      );

                                      // cleanup
                                      setTempUploadedImages([]);
                                      setTempSelectedImages([]);
                                      setUploadColor("");
                                      setEditMode(false);
                                      setEditingGroupIndex(null);
                                      setEditingGroupSource(null);
                                      setColorModal(false);
                                    }}
                                  >
                                    Apply Selection
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* SIZE CRUD MODAL */}
                        {sizeModal.show && (
                          <div
                            className="modal d-block"
                            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                          >
                            <div className="modal-dialog modal-sm modal-dialog-centered">
                              <div className="modal-content border-0 shadow-lg">
                                <div className="modal-header bg-light py-2">
                                  <h6 className="modal-title fw-bold">
                                    {sizeModal.mode === "add"
                                      ? "Add New Size"
                                      : "Rename Size"}
                                  </h6>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() =>
                                      setSizeModal({
                                        ...sizeModal,
                                        show: false,
                                      })
                                    }
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <label className="form-label small fw-bold text-muted text-uppercase">
                                    Size Name
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    autoFocus
                                    value={sizeModal.value}
                                    onChange={(e) =>
                                      setSizeModal({
                                        ...sizeModal,
                                        value: e.target.value,
                                      })
                                    }
                                    onKeyDown={(e) =>
                                      e.key === "Enter" && handleSaveSize()
                                    }
                                    placeholder="e.g. 15, 2.5ct, Large"
                                  />
                                </div>
                                <div className="modal-footer border-0 pt-0">
                                  <button
                                    type="button"
                                    className="btn btn-light btn-sm fw-bold px-3"
                                    onClick={() =>
                                      setSizeModal({
                                        ...sizeModal,
                                        show: false,
                                      })
                                    }
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm fw-bold px-3 shadow-sm"
                                    onClick={handleSaveSize}
                                  >
                                    {sizeModal.mode === "add"
                                      ? "Create"
                                      : "Update"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* quality model table */}

                        {qualityModal.show && (
                          <div
                            className="modal d-block"
                            style={{ background: "rgba(0,0,0,0.5)" }}
                          >
                            <div className="modal-dialog modal-lg modal-dialog-centered">
                              <div className="modal-content shadow-lg">
                                <div className="modal-header">
                                  <div>
                                    <h6 className="fw-bold">
                                      Add Other Stone to{" "}
                                      {qualityModal?.quality?.quality}
                                    </h6>

                                    <div className="d-flex gap-2 mt-1">
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Add Type"
                                        value={diamondTypeInput}
                                        onChange={(e) =>
                                          setDiamondTypeInput(e.target.value)
                                        }
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-success"
                                        onClick={() => {
                                          if (!diamondTypeInput.trim()) return;

                                          // prevent duplicates
                                          if (
                                            diamondTypes.includes(
                                              diamondTypeInput,
                                            )
                                          )
                                            return;

                                          setDiamondTypes((prev) => [
                                            ...prev,
                                            diamondTypeInput,
                                          ]);
                                          setDiamondTypeInput("");
                                        }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>

                                  <button
                                    className="btn-close"
                                    onClick={() =>
                                      setQualityModal({
                                        show: false,
                                        varId: null,
                                        metalSizeId: null,
                                        diamondSizeId: null,
                                        diamondIndex: null,
                                        qualityIndex: null,
                                        quality: null,
                                      })
                                    }
                                  />
                                </div>

                                <div className="modal-body">
                                  <table className="table table-sm table-bordered align-middle">
                                    <thead className="table-light small">
                                      <tr>
                                        <th>Type</th>
                                        <th>MM</th>
                                        <th>Stones</th>
                                        <th>Price</th>
                                        <th>Labour</th>
                                        <th>Making</th>
                                        <th></th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {otherTypesDraft.map((row, i) => (
                                        <tr key={i}>
                                          <td>
                                            <select
                                              className="form-select form-select-sm"
                                              value={row.typeName}
                                              onChange={(e) =>
                                                updateOtherTypeRow(
                                                  i,
                                                  "typeName",
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              <option value="">Select</option>
                                              {diamondTypes.map((d) => (
                                                <option key={d} value={d}>
                                                  {d}
                                                </option>
                                              ))}
                                            </select>
                                          </td>

                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              value={row.mmSize}
                                              onChange={(e) =>
                                                updateOtherTypeRow(
                                                  i,
                                                  "mmSize",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              value={row.stones}
                                              onChange={(e) =>
                                                updateOtherTypeRow(
                                                  i,
                                                  "stones",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              value={row.price}
                                              onChange={(e) =>
                                                updateOtherTypeRow(
                                                  i,
                                                  "price",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              value={row.labour}
                                              onChange={(e) =>
                                                updateOtherTypeRow(
                                                  i,
                                                  "labour",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              value={row.making}
                                              onChange={(e) =>
                                                updateOtherTypeRow(
                                                  i,
                                                  "making",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td className="text-center">
                                            <button
                                              className="btn btn-sm btn-outline-danger"
                                              onClick={() =>
                                                removeOtherTypeRow(i)
                                              }
                                            >
                                              ×
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>

                                  <button
                                    type="button"
                                    className="btn btn-link btn-sm fw-bold"
                                    onClick={addOtherTypeRow}
                                  >
                                    + Add Another Stone
                                  </button>

                                  <div className="p-2 bg-light rounded small">
                                    Quality Price: $
                                    {qualityModal?.quality?.finalPrice} <br />
                                    Other Stones Price: $
                                    {otherTypesDraft?.reduce(
                                      (s, o) =>
                                        s +
                                        Number(o.price || 0) +
                                        Number(o.labour || 0) +
                                        Number(o.making || 0),
                                      0,
                                    )}{" "}
                                    <br />
                                    <strong>
                                      Total:{" "}
                                      {Number(
                                        qualityModal?.quality?.finalPrice || 0,
                                      ) +
                                        otherTypesDraft?.reduce(
                                          (s, o) =>
                                            s +
                                            Number(o.price || 0) +
                                            Number(o.labour || 0) +
                                            Number(o.making || 0),
                                          0,
                                        )}
                                    </strong>
                                  </div>
                                </div>

                                <div className="modal-footer">
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() =>
                                      setQualityModal({
                                        show: false,
                                        varId: null,
                                        metalSizeId: null,
                                        diamondSizeId: null,
                                        diamondIndex: null,
                                        qualityIndex: null,
                                        quality: null,
                                      })
                                    }
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={saveOtherTypeToQuality}
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="mb-3 row">
                        <div className="d-flex flex-reverse flex-wrap gap-2">
                          <a
                            className="btn btn-danger"
                            onClick={() => Navigate("/showProduct")}
                          >
                            <i className="fas fa-window-close"></i>
                            Cancel{" "}
                          </a>
                          <button
                            disabled={loading}
                            type="button"
                            className="btn btn-success"
                            onClick={handleSubmit}
                          >
                            <i className="fas fa-save"></i>{" "}
                            {loading ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </div>

                      <AlertBox
                        status={productAddStatus}
                        statusMessage={statusMessage}
                      />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProduct;
